import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME,
  MODAL_INSTANT_FORMS_EMPTY_TEXT,
  MODAL_LEAD_FORMS_DUPLICATE_AND_EDIT,
  MODAL_LEAD_FORMS_VIEW,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { BORDER_RADIUS } from "../../utils/constants";
import { INPUT_COLOR_BORDER } from "../../utils/colors";
import { META_INSTANT_FORM_ACTION_BOOK_TIME } from "../../utils/metaInstantForm";
import Loader from "../Loaders/Loader";
import IconButton from "../Buttons/IconButton";

export const InstantFormsList = ({
  instantForms = [],
  loadLastItem,
  selectedItem,
  onChangeSelectedItem,
  onDuplicateInstantForm = () => {},
  onViewInstantForm = () => {},
  lastItemRef,
}) => {
  const { t } = useTranslationApp();

  const instantFormsSorted = [...instantForms].sort(
    (a, b) => (b.creationTime || 0) - (a.creationTime || 0)
  );

  if (instantForms.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 200,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {t(MODAL_INSTANT_FORMS_EMPTY_TEXT)}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <RadioGroup
        value={selectedItem || ""}
        onChange={(e) => onChangeSelectedItem(e.target.value)}
      >
        {instantFormsSorted.map((instantForm, index) => {
          const isLastItem = index === instantFormsSorted.length - 1;
          const hasDetail = Boolean(instantForm.duplicateValues);
          const isBookTime =
            instantForm.duplicateValues?.thankYouAction ===
            META_INSTANT_FORM_ACTION_BOOK_TIME;

          return (
            <Box
              key={instantForm.id}
              ref={isLastItem ? lastItemRef : undefined}
              sx={{
                mb: 1,
                p: 1.5,
                border: `1px solid ${INPUT_COLOR_BORDER}`,
                borderRadius: BORDER_RADIUS,
                display: "flex",
                alignItems: "flex-start",
                gap: 0.5,
              }}
            >
              <FormControlLabel
                value={instantForm.id}
                control={<Radio />}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.25,
                      minWidth: 0,
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
                    >
                      {instantForm.name}
                    </Typography>
                    {isBookTime && (
                      <Typography variant="caption" color="text.secondary">
                        {t(MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME)}
                      </Typography>
                    )}
                  </Box>
                }
                sx={{
                  flex: 1,
                  minWidth: 0,
                  m: 0,
                  alignItems: "flex-start",
                  "& .MuiFormControlLabel-label": {
                    minWidth: 0,
                    width: "100%",
                  },
                }}
              />
              {hasDetail && (
                <>
                  <IconButton
                    tooltipText={MODAL_LEAD_FORMS_VIEW}
                    edge={false}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      onViewInstantForm(instantForm);
                    }}
                    sx={{ p: 0.5, mt: -0.25 }}
                  >
                    <VisibilityOutlinedIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                  {instantForm.isDuplicable !== false && (
                    <IconButton
                      tooltipText={MODAL_LEAD_FORMS_DUPLICATE_AND_EDIT}
                      edge={false}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        onDuplicateInstantForm(instantForm);
                      }}
                      sx={{ p: 0.5, mt: -0.25 }}
                    >
                      <ContentCopyOutlinedIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  )}
                </>
              )}
            </Box>
          );
        })}
      </RadioGroup>
      {!loadLastItem && <Loader size={20} />}
    </Box>
  );
};
